/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Composables
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

import { pt } from "vuetify/locale";

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
    locale: {
        locale: "pt", // Define o idioma padrão para 'pt-BR'
        messages: { pt },
    },
    defaults: {
        VTextField: {
            variant: "outlined",
            density: "compact",
        },
        VSelect: {
            variant: "outlined",
            density: "compact",
        },
        VAutocomplete: {
            variant: "outlined",
            density: "compact",
        },
        VCombobox: {
            variant: "outlined",
            density: "compact",
        },
        VTextarea: {
            variant: "outlined",
            density: "compact",
        },
        VFileInput: {
            variant: "outlined",
            density: "compact",
        }
    },
    components,
    directives,
    /*theme: {
      themes: {
        light: {
          dark: false, // Define se é um tema escuro (false para claro)
          colors: {
            primary: '#1976D2', // Azul padrão
            secondary: '#424242', // Cinza
            accent: '#82B1FF', // Azul claro
            error: '#FF5252', // Vermelho
            info: '#2196F3', // Azul
            success: '#4CAF50', // Verde
            warning: '#FFC107', // Amarelo
          },
        },
      }
    }*/
    theme: {
        themes: {
            light: {
                dark: false,
                colors: {
                    primary: "#1E88E5", // Azul confiável e moderno
                    secondary: "#546E7A", // Cinza azulado elegante
                    accent: "#90CAF9", // Azul claro para destaques
                    error: "#E53935", // Vermelho sóbrio
                    info: "#039BE5", // Azul mais vibrante
                    success: "#43A047", // Verde moderado e profissional
                    warning: "#FB8C00", // Laranja escuro, menos agressivo que o amarelo puro
                    background: "#F9FAFB", // Cinza bem claro, quase branco (limpo e moderno)
                    surface: "#FFFFFF", // Branco puro para cards e containers
                },
            },
        },
    },
});
